import { AxiosError } from 'axios';
import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance';
import { GET_URL_NEW } from '@utils/api/endpoints';
import { BaseError, BaseResponse } from '@utils/types/shared/base';
import { useNewAppSearchParams } from '@utils/hooks/use-new-app-search-params';

export interface SubOrganization {
  id: number;
  name: string;
  email: string;
  registration_date: string;
  is_active: boolean;
  is_deleted: boolean;
  country: string;
}

export type SubOrganizationsResponse = BaseResponse<SubOrganization[]>;

export const useGetCustomersSubOrganizationsBo = (resellerId: number) => {
  const { searchParams } = useNewAppSearchParams();

  const offset = Number.isFinite(Number(searchParams.offset))
    ? Number(searchParams.offset)
    : 0;
  const limit = Number.isFinite(Number(searchParams.limit))
    ? Number(searchParams.limit)
    : 25;

  const sortField = (searchParams.sort as string | undefined) || undefined;
  const sortDirection =
    (searchParams.direction as 'asc' | 'desc' | undefined) || undefined;

  const qString = (searchParams.q as string | undefined) || undefined;

  const fetchSubOrganizations = async () => {
    const { subOrganizationsByResellerId } = GET_URL_NEW({
      offset,
      limit,
      q: qString,
      sort: sortField,
      direction: sortDirection
    });

    const url = subOrganizationsByResellerId(resellerId);
    const { data } = await Axios.get<SubOrganizationsResponse>(url);
    return data;
  };

  return useQuery<SubOrganizationsResponse, AxiosError<BaseError>>(
    [
      'customersSubOrgs',
      resellerId,
      offset,
      limit,
      qString,
      sortField,
      sortDirection
    ],
    fetchSubOrganizations,
    {
      enabled: Number.isFinite(resellerId) && resellerId > 0,
      keepPreviousData: true,
      refetchOnWindowFocus: true,
      refetchInterval: 15000,
      refetchIntervalInBackground: true,
      staleTime: 8000,
      useErrorBoundary: false
    }
  );
};
